import { useState } from "react";
import Input from "../../components/preview-input/input";
import useOrderStore from "../../store/order-store";
import { useLocation } from "react-router-dom";
import { colorList } from "../../utils/formats";

function YesNoColorSelection() {
  const { orderData,  setFormData } = useOrderStore();
  const isSelected = orderData.roof;
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const hasSheet = queryParams.get('hasSheet');
  const isDisabled =(hasSheet === 'true');
  const handleInputChange = (value) => {
    if(isDisabled){
      return
    }
    setFormData({ 
      ...orderData,
      roof: value
     });
  };
  const handleInputChange2 = (field) => (e) => {
    setFormData({
      ...orderData,
      [field]: e.target.value
    });
  };
  return (
    <div className="k-display-flex k-flex-wrap k-mt-1">
      {/* <div className="k-pos-relative k-top-1" style={{ width: "100px" }}>
        <Input value={orderData.roofValue} onChange={handleInputChange2('roofValue')}/>
      </div> */}
      <h4 className="k-m-0 k-font-light k-pt-2 k-sm-w-100">Spring Clips Required:</h4>

      <h4 className="k-m-0 k-font-light k-pt-2 k-ml-4 k-ml-sm-0 k-d-flex-sm-cloumn">
        <label>
          <input
          disabled={isDisabled}
            type="radio"
            name="selection"
            value="Yes"
            checked={isSelected === "Yes"}
            onChange={() => handleInputChange("Yes")}
            style={{ marginRight: "10px" }}
            className="k-ml-sm-0"
          />
          Yes
        </label>
        <label className="k-ml-sm-0 " style={{ marginLeft: "8px" }}>
          <input
          disabled={isDisabled}
            type="radio"
            name="selection"
            value="No"
            checked={isSelected === "No"}
            onChange={() => handleInputChange("No")}
            style={{ marginRight: "10px" }}
            className="k-ml-sm-0"
          />
          No
        </label>
        &nbsp; Color:
      </h4>

      <div className="k-pos-relative k-top-1 k-ml-3 k-sm-w-100 k-ml-sm-0" style={{ width: "100px" }}>
      <select disabled={isDisabled} value={orderData?.roofColor?.toUpperCase()} onChange={handleInputChange2('roofColor')} style={{width:"100%",height:"30px",borderRadius:"5px"}} id="colorSelect" name="color">
           {
          colorList.map((col)=>(
            <option value={col}>{col}</option>
          ))
           }
        </select>
        {/* <Input  value={orderData.roofColor} onChange={handleInputChange2('roofColor')}/> */}
      </div>
    </div>
  );
}

export default YesNoColorSelection;
